export interface StaffColor {
  bg: string;
  border: string;
  text: string;
  badge: string;
  badgeText: string;
}

const lightPalette: StaffColor[] = [
  // Amber
  {
    bg: "#fffbeb",
    border: "#fde68a",
    text: "#92400e",
    badge: "#fef3c7",
    badgeText: "#b45309",
  },
  // Blue
  {
    bg: "#eff6ff",
    border: "#bfdbfe",
    text: "#1e40af",
    badge: "#dbeafe",
    badgeText: "#1d4ed8",
  },
  // Purple
  {
    bg: "#faf5ff",
    border: "#e9d5ff",
    text: "#6b21a8",
    badge: "#f3e8ff",
    badgeText: "#7c3aed",
  },
  // Teal
  {
    bg: "#f0fdfa",
    border: "#99f6e4",
    text: "#115e59",
    badge: "#ccfbf1",
    badgeText: "#0d9488",
  },
  // Pink
  {
    bg: "#fdf2f8",
    border: "#f9a8d4",
    text: "#9d174d",
    badge: "#fce7f3",
    badgeText: "#db2777",
  },
];

const darkPalette: StaffColor[] = [
  // Amber
  {
    bg: "rgba(245,158,11,0.1)",
    border: "rgba(245,158,11,0.3)",
    text: "#fbbf24",
    badge: "rgba(245,158,11,0.15)",
    badgeText: "#fcd34d",
  },
  // Blue
  {
    bg: "rgba(59,130,246,0.1)",
    border: "rgba(59,130,246,0.3)",
    text: "#60a5fa",
    badge: "rgba(59,130,246,0.15)",
    badgeText: "#93c5fd",
  },
  // Purple
  {
    bg: "rgba(139,92,246,0.1)",
    border: "rgba(139,92,246,0.3)",
    text: "#a78bfa",
    badge: "rgba(139,92,246,0.15)",
    badgeText: "#c4b5fd",
  },
  // Teal
  {
    bg: "rgba(20,184,166,0.1)",
    border: "rgba(20,184,166,0.3)",
    text: "#2dd4bf",
    badge: "rgba(20,184,166,0.15)",
    badgeText: "#5eead4",
  },
  // Pink
  {
    bg: "rgba(236,72,153,0.1)",
    border: "rgba(236,72,153,0.3)",
    text: "#f472b6",
    badge: "rgba(236,72,153,0.15)",
    badgeText: "#f9a8d4",
  },
];

/**
 * Returns the color object for a staff member based on their display index.
 * Cycles through the 5-color palette if there are more staff members.
 */
export function getStaffColor(index: number, theme: "light" | "dark"): StaffColor {
  const palette = theme === "dark" ? darkPalette : lightPalette;
  return palette[index % palette.length];
}

/**
 * Builds a Map from staff ID to StaffColor for a list of staff IDs.
 * Order of the IDs determines the color assignment.
 */
export function buildStaffColorMap(
  staffIds: string[],
  theme: "light" | "dark"
): Map<string, StaffColor> {
  const map = new Map<string, StaffColor>();
  staffIds.forEach((id, index) => {
    map.set(id, getStaffColor(index, theme));
  });
  return map;
}
